<div class="text-center">
    <h2 class="m-0 pt-1">{{ title|translate }}</h2>
    <div mat-dialog-content>
        <mat-icon>wifi_off</mat-icon>
    </div>
</div>
